import { render, staticRenderFns } from "./SampleTT.vue?vue&type=template&id=23ca01ab&scoped=true"
import script from "./SampleTT.vue?vue&type=script&lang=js"
export * from "./SampleTT.vue?vue&type=script&lang=js"
import style0 from "./SampleTT.vue?vue&type=style&index=0&id=23ca01ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ca01ab",
  null
  
)

export default component.exports